import React, { Component } from 'react';

export default class InputInitialForm extends Component {
    constructor(props) {
        super(props);
    }

    inputFocus = event => {
        let elem = event.target,
            input = elem.tagName === 'INPUT' ?
                    elem :
                    elem.parentNode.querySelector('input');

        input.removeAttribute('readonly');
        input.classList.add('active');
        input.focus();
    }

    checkValueInputs = () => {
        let inputs = document.querySelectorAll(
            'form input[type=text], form input[type=password]'
        )
        inputs.forEach(item => {
            if (item.value) item.classList.add('active')
            else item.classList.remove('active')
        })
    }

    render() {
        return <input
                    defaultValue=""
                    type={this.props.type}
                    name={this.props.name}
                    autoComplete="off"
                    title={this.props.title}
                    onFocus={this.inputFocus}
                    onBlur={this.checkValueInputs}
                    readOnly
                    required
                />;
    }
}